import {lazy} from "react";

export const ReportFuelConsumptionByDeviceLazy = lazy(()=>import('./ReportFuelConsumptionByDevice'))